module.exports = __webpack_public_path__ + "img/youre_doing_well.98581b1b.svg";